<template>
  <Icon
    v-bind="$attrs"
    :height="sizePx"
    :width="sizePx"
  />
</template>

<script setup>
import { Icon } from '@iconify/vue'
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

/**
 * Icon size
 *
 * @type {{ size: 'xs' | 'sm' }}
 */
const props = defineProps({
  size: {
    type: [String, Number],
    validator: v => ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].includes(v) || !isNaN(+v),
    default: 'sm',
  },
})

const sizes = { xs: 12, sm: 18, md: 24, lg: 36, xl: 48, xxl: 64 }
const sizePx = computed(() => (isNaN(props.size) ? (sizes[props.size] ?? sizes.sm) : props.size))
</script>
